export default __webpack_public_path__ + "static/media/Pilgrim's Helmet.3dc695c2.jpg";